import React from 'react';
import {
  generatePath,
  Link,
  matchPath,
  RouteComponentProps,
  withRouter,
} from 'react-router-dom';
import { Button } from 'reactstrap';

type MatchParams = { organizationId: string; practitionerId: string };

const EditPractitionerButton = (
  props: RouteComponentProps<{
    organizationId: string;
    practitionerId: string;
  }> & {
    loading?: boolean;
    className?: string;
  },
) => {
  const path =
    '/organization/:organizationId/practitioner/:practitionerId/edit';
  const match = matchPath<MatchParams>(props.location.pathname, {
    path: '/organization/:organizationId/practitioner/:practitionerId',
  });
  const gPath = match ? generatePath(path, match.params) : undefined;
  return (
    <Button
      tag={Link}
      color="success"
      className={
        props.className ? `${props.className} text-center` : 'text-center'
      }
      to={gPath}
      disabled={!gPath || props.loading}>
      Edit
    </Button>
  );
};

export default withRouter(EditPractitionerButton);
